import React from "react";
import {connect} from "react-redux";
import {DEFAULT_PER_PAGE} from "../../config";
import {Button, Col, Row, Space, Table, Tag, Tooltip, Typography} from "antd";
import {updatePage} from "../../actions/page";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {DateTimeFormat} from "../shared/DateTimeFormat";
import {DeleteOutlined, EyeOutlined, FilterOutlined} from "@ant-design/icons";
import {loadCompanyEmails} from "../../actions/account";
import CompanyEmailViewModal from "./CompanyEmailViewModal";
import EmailsTableFilter from "../EmailsTableFilter";
import AccessGate from "../permissions/AccessGate";

class CompanyEmails extends React.Component {
    state = {
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        emails: [],
        loadingEmails: true,
        activeEmail: null,
        showEmailModal: false,
        filters: []
    };

    componentDidMount() {
        this.props.updatePage('Emails');
        this.loadEmails();
    }

    clearFilters() {
        this.setState({ filters: [] }, () => this.loadEmails());
    }

    setFilter(filter) {
        let filters = this.state.filters.filter(f => f.key !== filter.key);
        filters.push(filter);

        let pagination = {...this.state.pagination, current: 1};

        this.setState({ filters, pagination }, () => this.loadEmails());
    }

    removeFilter(item) {
        let filters = this.state.filters.filter(filter => filter.key !== item.key);
        this.setState({ filters }, () => this.loadEmails());
    }

    showFilters() {
        return this.state.filters.map((filter, i) => {
            let value;

            if (typeof filter.value === 'boolean') {
                if (filter.value) {
                    value = 'Yes';
                } else {
                    value = 'No';
                }
            } else {
                if (filter.visible !== null) {
                    value = filter.visible;
                } else {
                    value = normalizeEnum(filter.value);
                }
            }

            return <Tag key={i} closable onClose={() => this.removeFilter(filter)}>{filter.name}: {value}</Tag>;
        });
    }

    loadEmails(page = null, per_page = null) {
        if(page === null) {
            page = this.state.pagination.current;
        }

        if(per_page === null) {
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingEmails: true });

        this.props.loadCompanyEmails(this.props.companyGuid, page, per_page, this.state.filters, (res) => {
            this.setState({ emails: res.data.data, loadingEmails: false, pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingEmails: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        const { Link } = Typography;

        const columns = [
            { title: 'Subject', dataIndex: 'subject', render: (item, record) => <Link onClick={() => this.setState({ activeEmail: record.guid, showEmailModal: true })}>{item}</Link>},
            { title: 'Sent', dataIndex: 'date_sent', render: (item, record) => record.is_sent ? <DateTimeFormat value={item} /> : 'Scheduled' },
            { align: 'right', render: (item, record) => <Button size='small' onClick={() => this.setState({ activeEmail: record.guid, showEmailModal: true })} icon={<EyeOutlined />}>View</Button>}
        ];

        return(
            <AccessGate scopes={['can_view_company_emails']}>
                <p>{this.showFilters()}</p>

                <Row justify='space-between' style={{marginBottom: '10px'}}>
                    <Col>
                        <Space>
                            <Button type='text' icon={<FilterOutlined/>}
                                    onClick={() => this.setState({showFiltersModal: true})}>Filters</Button>
                            <Button type='text' disabled={this.state.filters.length === 0}
                                    onClick={() => this.clearFilters()} icon={<DeleteOutlined/>}>Clear Filters</Button>
                        </Space>
                    </Col>
                    <Col>
                        <Tooltip title='Reload table'><Button type='text' icon={<UndoOutlined/>}
                                                              onClick={() => this.loadEmails()}/></Tooltip>
                    </Col>
                </Row>

                <div style={{overflowX: 'auto'}}>
                    <Table
                        columns={columns}
                        rowKey={(item) => item.guid}
                        dataSource={this.state.emails}
                        loading={this.state.loadingEmails}
                        pagination={this.state.pagination}
                        onChange={(pagination) => this.loadEmails(pagination.current, pagination.pageSize)}
                    />
                </div>

                    <EmailsTableFilter
                        showModal={this.state.showFiltersModal}
                        closeModal={() => this.setState({showFiltersModal: false})}
                        onChange={(filter) => this.setFilter(filter)}/>

                    <CompanyEmailViewModal guid={this.state.activeEmail}
                                           companyGuid={this.props.companyGuid}
                                           showModal={this.state.showEmailModal}
                                           close={() => this.setState({showEmailModal: false, activeEmail: null})}/>
            </AccessGate>
    );
    }
    }

    export default connect(null, { updatePage, loadCompanyEmails })(CompanyEmails);